import { toast } from "../toast/toast";
import { ReagentLog, User } from "../../../backend/src/types";
import { GetReagentInfoRes } from "../components/tabs/InfoTab";
import { ENDPOINT } from "../endpoint/endpoint";
import { errorMessage } from "../function/errorMessage";

type Response<T> = {
  data: T;
  error?: any;
};

interface UpdateReagentQuantityPayload {
  sendReagentLog: ReagentLog;
}

export async function updateReagentQuantity(
  payload: UpdateReagentQuantityPayload
) {
  try {
    const res = await fetch(ENDPOINT.log.updateReagentQuantity, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (res.status === 409) {
      toast.error(
        "更新に失敗しました:DB情報が最新のDB情報と一致していません。再読み込みを行います。"
      );
      return 409;
    }

    if (res.status === 204) {
      return;
    }

    if (!res.ok) {
      const { error }: Response<null> = await res.json();
      throw new Error(error ?? "Server Error");
    }
  } catch (error) {
    errorMessage("試薬残量の更新に失敗しました。", error);
  }
}

interface GetReagentLogListPayload {
  reagent_id: number;
}

interface ReagentLogListResponse {
  logs: ReagentLog[];
  users: User[];
  managers: User[];
}

export async function getReagentLogList(
  payload: GetReagentLogListPayload
): Promise<ReagentLogListResponse | null> {
  try {
    const res = await fetch(ENDPOINT.log.getReagentLogList, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const { data, error }: Response<ReagentLogListResponse> = await res.json();

    if (!res.ok) {
      throw new Error(error ?? "Server Error");
    }

    return data;
  } catch (error) {
    errorMessage("ユーザーリストの取得に失敗しました。", error);
    return null;
  }
}

interface GetReagentInfoPayload {
  group_id: number;
}

export async function getReagentInfo(
  payload: GetReagentInfoPayload
): Promise<GetReagentInfoRes | null> {
  try {
    const res = await fetch(ENDPOINT.log.getReagentInfo, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const { data, error }: Response<GetReagentInfoRes> = await res.json();

    if (!res.ok) {
      throw new Error(error ?? "Server Error");
    }

    return data;
  } catch (error) {
    errorMessage("試薬情報の取得に失敗しました。", error);
    return null;
  }
}
